import { render, staticRenderFns } from "./SectionAccomodation.vue?vue&type=template&id=292d4580&scoped=true"
import script from "./SectionAccomodation.vue?vue&type=script&lang=js"
export * from "./SectionAccomodation.vue?vue&type=script&lang=js"
import style0 from "./SectionAccomodation.vue?vue&type=style&index=0&id=292d4580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292d4580",
  null
  
)

export default component.exports